export default __webpack_public_path__ + "static/media/logo_Agap2IT.6f399928.svg";